import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "utils/api";
import { setLogin } from "state";
import { useTeamLocale } from "./TeamLocaleContext";
import "styles/auth.css";

const TeamLogin = ({ onSuccess }) => {
  const { t } = useTeamLocale();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const { data } = await api.post("/auth/login", form);
      if (!data.user?.isAdmin) {
        setError(t("login.noAccess"));
        return;
      }
      dispatch(setLogin({ token: data.token, user: data.user }));
      onSuccess?.();
    } catch (err) {
      setError(err?.response?.data?.message || t("login.failed"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="team-login">
      <div className="auth-card team-login-card">
        <p className="auth-kicker">{t("login.kicker")}</p>
        <h1>
          {t("login.title")} <em>{t("login.titleEm")}</em>
        </h1>
        <p className="auth-lead">{t("login.lead")}</p>

        {error && <div className="auth-alert is-error">{error}</div>}

        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          <div>
            <label htmlFor="team-login-email">{t("login.email")}</label>
            <input
              id="team-login-email"
              type="email"
              autoComplete="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <div>
            <label htmlFor="team-login-password">{t("login.password")}</label>
            <input
              id="team-login-password"
              type="password"
              autoComplete="current-password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </div>
          <div className="auth-actions">
            <button type="submit" className="auth-submit" disabled={submitting}>
              {submitting ? t("login.submitting") : t("login.submit")}
            </button>
          </div>
        </form>

        <div className="auth-links">
          <Link to="/auth/passwort-vergessen">{t("login.forgotPassword")}</Link>
          <Link to="/">{t("login.backToSite")}</Link>
        </div>
      </div>
    </section>
  );
};

export default TeamLogin;
